var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionPoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_1570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1V11.53C19.51 10.85 18.8 10.36 18 10.14V1C18 0.45 18.45 0 19 0C19.55 0 20 0.45 20 1ZM13 4.99999C12.45 4.99999 12 5.44999 12 5.99999V14.76L12.1121 14.5774C12.5251 13.9043 13.9022 11.6601 14 11.53V5.99999C14 5.44999 13.55 4.99999 13 4.99999ZM8 23C8 23.552 7.553 24 7 24C6.447 24 6 23.552 6 23V12C6 11.448 6.447 11 7 11C7.553 11 8 11.448 8 12V23ZM24 22.295C24 21.961 23.906 21.644 23.744 21.405L18.464 12.826C18.163 12.317 17.603 12 17 12C16.397 12 15.837 12.317 15.544 12.815L10.273 21.38C10.094 21.645 9.99998 21.961 9.99998 22.295C9.99998 23.235 10.768 24 11.712 24H22.288C23.232 24 24 23.235 24 22.295ZM17 22.5C16.448 22.5 16 22.052 16 21.5C16 20.948 16.448 20.5 17 20.5C17.552 20.5 18 20.948 18 21.5C18 22.052 17.552 22.5 17 22.5ZM18 18.5C18 19.052 17.553 19.5 17 19.5C16.447 19.5 16 19.052 16 18.5V15.5C16 14.948 16.447 14.5 17 14.5C17.553 14.5 18 14.948 18 15.5V18.5ZM1 24C1.553 24 2 23.552 2 23V16C2 15.448 1.553 15 1 15C0.447 15 0 15.448 0 16V23C0 23.552 0.447 24 1 24Z",
    fill: "#DAA403"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_1570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionPoor);
export default __webpack_public_path__ + "static/media/connection-poor.26ac1b68bf475c0276511b89a02f2a01.svg";
export { ForwardRef as ReactComponent };